import PropTypes from 'prop-types';
import React from 'react'; // eslint-disable-line no-unused-vars

const { arrayOf, bool, number, oneOfType, shape, string } = PropTypes; // eslint-disable-line no-unused-vars

export default shape({
  teamName: string,
  displayName: string,
  description: string,
  thumbnailUrl: string,
  accentColor: string,
  allowedCIDRs: arrayOf(string),
  ownerUsername: string,
  ownerEmail: string,
  slackToken: string,
  samlConfig: shape({
    loginUrl: string,
    logoutUrl: string,
    entityId: string,
    certificate: string,
    enabled: bool
  }),
  slackIntegration: shape({
    slackToken: string,
    slackTeam: string,
    slackTeamID: string,
    integrationUser: string
  })
});



// WEBPACK FOOTER //
// ./js/types/api/team.js